<div class="lexgo-place">
  <div class="lexgo-place__hint alert alert-light border small mb-2">
    Arrastre un firmante al documento y suéltelo donde debe ir la firma.
    También puede arrastrar una firma ya colocada para moverla. Cada firmante necesita una posición.
  </div>

  @if (errorMessage) {
    <div class="alert alert-danger small">{{ errorMessage }}</div>
  }

  <div class="lexgo-place__layout">
    <aside class="lexgo-place__signers">
      <div class="small font-weight-bold mb-2">Firmantes</div>
      @for (s of signers; track s.email; let i = $index) {
        <div
          class="lexgo-place__signer"
          [class.lexgo-place__signer--done]="hasPlacement(i)"
          [class.lexgo-place__signer--dragging]="draggingIndex === i"
          draggable="true"
          (dragstart)="onSignerDragStart($event, i)"
          (dragend)="onDragEnd()"
        >
          <div class="lexgo-place__signer-drag" title="Arrastrar al PDF">
            <i class="fas fa-grip-vertical"></i>
          </div>
          <div class="lexgo-place__signer-body">
            <div class="font-weight-bold">{{ signerFullName(i) }}</div>
            @if (signerIdentification(i)) {
              <div class="text-muted small">{{ signerIdentification(i) }}</div>
            }
            <div class="text-muted small">{{ s.email }}</div>
            <div class="lexgo-place__signer-status">
              @if (hasPlacement(i)) {
                <span class="text-success">Posicionado</span>
                <a href="javascript:void(0)" class="ml-2" (click)="clearSigner(i); $event.preventDefault()">Quitar</a>
              } @else {
                <span class="text-muted">Arrastre al PDF</span>
              }
            </div>
          </div>
        </div>
      }
      <div class="text-muted small mt-2">
        Firmas posicionadas:
        {{ placements?.length || 0 }} / {{ signers?.length || 0 }}
      </div>
    </aside>

    <div class="lexgo-place__viewer">
      <div class="lexgo-place__toolbar">
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="prevPage()" [disabled]="currentPage <= 1 || loading">
          ←
        </button>
        <span class="small mx-2">Página {{ currentPage }} / {{ pageCount || '…' }}</span>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="nextPage()"
          [disabled]="currentPage >= pageCount || loading"
        >
          →
        </button>
        @if (loading) {
          <span class="text-muted small ml-2">Cargando…</span>
        }
        @if (draggingIndex != null) {
          <span class="badge badge-info ml-2">Suelte en el PDF: {{ signerLabel(draggingIndex) }}</span>
        }
      </div>

      <div
        class="lexgo-place__canvas-wrap"
        #canvasWrap
        [class.lexgo-place__canvas-wrap--drop]="draggingIndex != null"
        (dragover)="onCanvasDragOver($event)"
        (drop)="onCanvasDrop($event)"
      >
        <canvas #pdfCanvas class="lexgo-place__canvas"></canvas>
        @for (m of markersOnPage; track m.recipientIndex) {
          <div
            class="lexgo-place__marker"
            [class.lexgo-place__marker--full]="isFullStyle"
            [class.lexgo-place__marker--simple]="!isFullStyle"
            [class.lexgo-place__marker--moving]="movingIndex === m.recipientIndex"
            [ngStyle]="markerStyle(m)"
            (pointerdown)="onMarkerPointerDown($event, m)"
            (dragover)="onCanvasDragOver($event)"
            (drop)="onCanvasDrop($event)"
          >
            @if (isFullStyle) {
              <div class="lexgo-place__stamp">
                <div class="lexgo-place__stamp-main">
                  <div class="lexgo-place__stamp-left">
                    <div class="lexgo-place__stamp-sigline" aria-hidden="true"></div>
                    <div class="lexgo-place__stamp-data">
                      <div>Nombre: {{ signerFullName(m.recipientIndex) }}</div>
                      @if (signerIdentification(m.recipientIndex)) {
                        <div>C.I. N° {{ signerIdentification(m.recipientIndex) }}</div>
                      } @else {
                        <div>C.I. N° —</div>
                      }
                      <div>Email: {{ signerEmail(m.recipientIndex) }}</div>
                    </div>
                  </div>
                  <div class="lexgo-place__stamp-qr" aria-hidden="true" title="QR">
                    <div class="lexgo-place__qr-grid">
                      @for (cell of qrPreviewCells; track $index) {
                        <span [class.lexgo-place__qr-cell--on]="cell"></span>
                      }
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="lexgo-place__stamp-quitar"
                  (click)="removePlacement(m)"
                  title="Quitar"
                >
                  Quitar
                </button>
              </div>
            } @else {
              <div class="lexgo-place__stamp lexgo-place__stamp--simple">
                <div class="lexgo-place__stamp-sigline" aria-hidden="true"></div>
                <div class="lexgo-place__stamp-data">
                  <div>Nombre: {{ signerFullName(m.recipientIndex) }}</div>
                  @if (signerIdentification(m.recipientIndex)) {
                    <div>C.I. N° {{ signerIdentification(m.recipientIndex) }}</div>
                  } @else {
                    <div>C.I. N° —</div>
                  }
                  <div>Email: {{ signerEmail(m.recipientIndex) }}</div>
                </div>
                <button
                  type="button"
                  class="lexgo-place__stamp-quitar"
                  (click)="removePlacement(m)"
                  title="Quitar"
                >
                  Quitar
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
